import { Background, BackgroundVariant, useStore } from '@xyflow/react';

const DOT_GAP = 16;

const DOT_SIZE = 1;

// Figma's canvas: 1px dots every 16px, soft-pearl 500 at 60%. React Flow scales the grid
// with the zoom, which shrank the dots to nothing at the opening zoom, so they keep their
// on-screen size and only pan with the chart.
const StructureDotGrid = () => {
  const zoom = useStore((state) => state.transform[2]);
  return (
    <Background
      variant={BackgroundVariant.Dots}
      gap={DOT_GAP / zoom}
      size={DOT_SIZE / zoom}
      color="var(--pf-color-soft-pearl-500)"
      style={{ opacity: 0.6 }}
    />
  );
};

export { StructureDotGrid };
